import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ResponseInterceptor } from './shared/services/response-interceptor';
import { UserAuthenticateGuard } from './shared/services/user-authenticate.gaurd';
import { UserSharedService } from './shared/services/user-shared.service';
import { ConfirmService } from './shared/services/confirm.service';
import { SharedModule } from './shared/shared.module';
import { EncryptionService } from "./shared/services/encryption.service"

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
      HttpClientModule,
      BrowserAnimationsModule, SharedModule
  ],
  providers: [
      CookieService, UserSharedService, ConfirmService,
      UserAuthenticateGuard,
      EncryptionService,
      { provide: HTTP_INTERCEPTORS, useClass: ResponseInterceptor, multi: true }
  ],
    bootstrap: [AppComponent],
    
})
export class AppModule { }
